// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1LcjU","tab":"Tabs_tab__3nw6X","active":"Tabs_active__3tV5C","content":"Tabs_content__2BPUo"};